export default __webpack_public_path__ + "static/media/CNWY.1b7034f5.png";